import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cn } from "@gymflow/helpers";
import { useContext, useEffect } from "react";
import { useHistory } from "react-router";

import { usePortalRoutes } from "../../hooks";
import { AuthenticationContext } from "../../providers/authentication/AuthenticationContext";
import { SignIn } from "../../providers/authentication/SessionOverlay/SignIn";
import { RouteFeature } from "../../routes";
import { Button } from "../atoms";
import HostedPagesOverlay from "./components/HostedPagesOverlay";

export const HostedPagesLogin = () => {
  const { createSiteOrEmbedLink } = usePortalRoutes();
  const history = useHistory();
  const auth = useContext(AuthenticationContext);

  const nextPageLink = createSiteOrEmbedLink(RouteFeature.SiteProfile);

  useEffect(() => {
    if (auth.userId) {
      history.replace(nextPageLink);
    }
  }, [auth, history, nextPageLink]);
  return (
    <HostedPagesOverlay isOpen>
      <div className="flex w-full items-center justify-end p-2">
        <Button
          onClick={() => history.replace(nextPageLink)}
          className="aspect-square size-10"
          intent="transparent"
        >
          <FontAwesomeIcon
            className="cursor-pointer text-xl text-gray-600"
            icon={faClose}
          />
        </Button>
      </div>
      <div
        className={cn(
          "flex h-full w-full max-w-[calc(100vw-2rem)] justify-center overflow-y-auto track-height-overlay",
        )}
      >
        <SignIn />
      </div>
    </HostedPagesOverlay>
  );
};
